import React from 'react';
import { FLAGS, useFlags } from 'hooks/useFlags';
import { SectionLink, SiteMap } from 'routing/siteMap';
import { OldFooter } from './OldFooter';
import { MetatheoryLogo } from 'icons/metatheory';
import { HorizontalDivider } from 'components/HorizontalDivider/HorizontalDivider';
import { NavbarItem } from 'components/Navbar/NavbarMenu';
import { Socials } from 'components/Socials/Socials';

import styles from './Footer.module.scss';

export default function Footer() {
  const { isFlagEnabled } = useFlags();

  function footerLink(props: SectionLink) {
    return <NavbarItem key={props.name} className={styles.item} {...props} />;
  }

  const footerSections = [
    [
      {
        sectionName: SiteMap.About.sectionName,
        sectionItems: SiteMap.About.links.map((item) => footerLink(item)),
      },
    ],
    [
      {
        sectionName: SiteMap.Story.sectionName,
        sectionItems: SiteMap.Story.links.map((item) => footerLink(item)),
      },
      {
        sectionName: SiteMap.Legal.sectionName,
        sectionItems: SiteMap.Legal.links.map((item) => footerLink(item)),
      },
    ],
    [
      {
        sectionName: 'Community',
        sectionItems: <Socials showNames className={styles.socials} />,
      },
    ],
    [
      {
        sectionName: SiteMap.Gallery.sectionName,
        sectionItems: SiteMap.Gallery.links.map((item) => footerLink(item)),
      },
    ],
    [
      {
        sectionName: SiteMap.Resources.sectionName,
        sectionItems: SiteMap.Resources.links.map((item) => footerLink(item)),
      },
    ],
    [
      {
        sectionName: SiteMap.Play.sectionName,
        sectionItems: SiteMap.Play.links.map((item) => footerLink(item)),
      },
    ],
  ];

  return isFlagEnabled(FLAGS.siteHierarchy) ? (
    <footer className={styles.footer}>
      <HorizontalDivider />
      <div className={styles.links}>
        {footerSections.map((section, index) => {
          return (
            <div key={index} className={styles.section}>
              {section.map((item) => {
                return (
                  <div key={item.sectionName}>
                    <h3>{item.sectionName}</h3>
                    {item.sectionItems}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className={styles.logo}>
        <MetatheoryLogo /> DuskBreakers © Metatheory 2022
      </div>
    </footer>
  ) : (
    <OldFooter />
  );
}
